<template>
  <div class="login_bg">
    <v-row class="m-0 p-0">
      <v-col class="d-none d-sm-block">
        <div class="main-bg">
          <lottie-player
            :src="'/all-assets/common/icon/animation/login/rand/'+(Math.floor(Math.random() * 5) + 1)+'.json'"
            background="transparent"
            loop
            mode="normal"
            speed="1"
            autoplay
          ></lottie-player>
        </div>
      </v-col>
      <v-col>
        <div class="main-bg position-relative flex-wrap" @click="showSuggestions = false">
          <div class="box">
            <v-form v-model="valid" lazy-validation>
              <form class="login_form" @submit.prevent="login()">
                <v-card-title class="justify-center">
                  <v-avatar size="40">
                    <img src="/all-assets/common/logo/cpb/cpbit.png" alt="CPB-IT" />
                  </v-avatar>
                  <b class="mx-3">CPB-IT Portal</b>
                </v-card-title>
                <v-card-text>
                  <v-col>
                    <v-menu
                      offset-y
                      v-model="showSuggestions"
                      transition="scale-transition"
                      :close-on-click="false"
                    >
                      <template v-slot:activator="{on}">
                        <v-text-field
                          label="Login ID"
                          placeholder="Enter AD ID (ponir.lol)"
                          v-model="form.login"
                          filled
                          rounded
                          dense
                          required
                          :rules="[rules.required, rules.min5, rules.max30]"
                          counter
                          v-on="suggestions ? on :''"
                        ></v-text-field>
                      </template>
                      <v-list dense>
                        <v-list-item
                          link
                          v-for="(suggestion, index) in suggestions"
                          :key="index"
                          @click="selectSuggestion(suggestion)"
                        >
                          <v-list-item-title>
                            <v-avatar size="30">
                              <img v-if="index" :src="'/images/users/small/' + index" alt="image" />
                              <img v-else src="/all-assets/common/img/no-image.png" alt="image" />
                            </v-avatar>
                            {{ suggestion }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>

                  <v-col>
                    <v-text-field
                      v-model="form.password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min8, rules.max30]"
                      :type="show1 ? 'text' : 'password'"
                      label="Password"
                      placeholder="Enter AD Password"
                      filled
                      rounded
                      dense
                      required
                      counter
                      @click:append="show1 = !show1"
                    ></v-text-field>
                  </v-col>

                  <v-col>
                    <v-btn
                      block
                      rounded
                      :loading="loading"
                      color="success"
                      type="submit"
                      :disabled="!valid"
                    >
                      Login
                      <v-icon right>mdi-login</v-icon>
                    </v-btn>
                  </v-col>

                  <!-- Links  -->
                  <div class="m-auto links mt-4">
                    <div class="m-auto">
                      <a
                        href="https://bdwacenter.cpbangladesh.com/RDWeb/Pages/en-US/password.aspx"
                        target="_blank"
                      >Password Expire or Change Password ?</a>
                      <v-btn
                        x-small
                        icon
                        @click="
                    openPdf(
                      { name: '/manuals/Change_Password.pdf' },
                      (pdfReadyLoading = true)
                    )
                  "
                        :loading="pdfReadyLoading"
                      >
                        <v-icon>mdi-book-open-page-variant-outline</v-icon>
                      </v-btn>
                    </div>

                    <!-- <div>
                  <router-link :to="{ name: 'Register' }">Register ?</router-link>
                  <v-btn
                    x-small
                    icon
                    @click="
                    openPdf(
                      { name: '/manuals/Register_Manual.pdf' },
                      (pdfReadyLoading = true)
                    )
                  "
                    :loading="pdfReadyLoading"
                  >
                    <v-icon>mdi-book-open-page-variant-outline</v-icon>
                  </v-btn>
                    </div>-->
                  </div>

                  <!-- Footer  -->
                  <div>
                    <p class="d-flex align-items-center justify-content-center mt-4 footer_text">
                      <img
                        src="https://asset.cpbangladesh.com/documents/cpbit_96_96_20220130055505qOomPLPI0l.png"
                        alt="cpb-it"
                        height="20px"
                      />
                      &nbsp;Powered by CPB-IT
                    </p>
                  </div>
                </v-card-text>
              </form>
            </v-form>
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- Help Line v-menu for click open, v-tooltip for hover open   -->
    <v-menu
      top
      :open-on-hover="!$vuetify.breakpoint.xs ? true : false"
      :open-on-click="$vuetify.breakpoint.xs ? true : false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="bottom_info_btn"
          dark
          v-bind="attrs"
          v-on="on"
          icon
          title="Help Line"
          style="z-index: 9999"
        >
          <img class="trin-trin" src="/all-assets/common/img/help-desk.png" height="80" weight="80" />
        </v-btn>
      </template>
      <v-card elevation="0" class="bg-transparent" style="border-radius: 15px 50px">
        <v-card-text class="bg-white">
          <p class="h4 text-center">IT Support</p>
          <table class="table footer_content_tbl">
            <tr>
              <th>Jillur Rahman</th>
              <td>
                <v-icon small>mdi-phone-in-talk</v-icon>
                <a href="tel:01324254025">01324-254025</a>
              </td>
            </tr>
            <tr>
              <th>Polash Mahamud</th>
              <td>
                <v-icon small>mdi-phone-in-talk</v-icon>
                <a href="tel:01787692530">01787-692530</a>
              </td>
            </tr>
            <tr>
              <th>Moniruzzaman</th>
              <td>
                <v-icon small>mdi-phone-in-talk</v-icon>
                <a href="tel:01787692529">01787-692529</a>
              </td>
            </tr>
          </table>

          <p class="h4 text-center">Application Support</p>
          <table class="table">
            <tr>
              <th>Aqib Ahmed</th>
              <td>
                <v-icon small>mdi-phone-in-talk</v-icon>
                <a href="tel:01324254058">01324-254058</a>
              </td>
            </tr>
            <tr>
              <th>Abul Kalam Azad</th>
              <td>
                <v-icon small>mdi-phone-in-talk</v-icon>
                <a href="tel:01766668845">01766-668845</a>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-menu>

    <!-- viewDocumentDialog -->
    <pdf-view v-if="pdfFileName" :key="Math.random()" :filename="pdfFileName" @openPdf="openPdf"></pdf-view>

    <!-- AnnouncementDialog -->
    <announcement-dialog v-if="announceDailogShow" :announceData="announcementMessage" />
  </div>
</template>

<script>
// lottie-player
import "@lottiefiles/lottie-player";
import Form from "vform";
import AnnouncementDialog from "./announcement";

export default {
  components: {
    AnnouncementDialog
  },
  data() {
    return {
      announce: true,

      passwordType: false,
      loading: false,
      password: null,

      // Form
      form: new Form({
        login: "",
        password: ""
      }),

      announcementMessage: "",
      announceDailogShow: false,
      // for pdf
      pdfFileName: "",
      pdfReadyLoading: false,

      // v-form
      valid: false,
      show1: false,

      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 30 || "Max 30 characters",
        min5: v => v.length >= 5 || "Min 5 characters",
        min8: v => v.length >= 8 || "Min 8 characters",
        max30: value => value.length <= 30 || "Max 30 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },

      // suggestions: ["saif.isl", "syfu.isl", "islam.isl", "rifat.ala"],
      suggestions: null,
      showSuggestions: false,
      selectedSuggestionIndex: 0,
      // tootripShow
      tootripShow: false
    };
  },

  methods: {
    // Login
    login() {
      this.loading = true;
      this.form
        .post("/login_action")
        .then(response => {
          console.log(response.data);
          let resData = response.data;

          // Success
          if (resData.status == "success") {
            // console.log(resData);
            // redirect with reload
            window.location.href = "/";
          }

          // Error
          if (resData.status == "error") {
            // suggestions
            if (resData.suggestions) {
              this.suggestions = [];
              // console.log("suggestions: ", resData.suggestions);
              this.suggestions = resData.suggestions;
              this.showSuggestions = true;
            } else {
              this.suggestions = [];
              this.showSuggestions = false;
            }

            // console.log(resData);
            Swal.fire({
              icon: "error",
              title: resData.title,
              text: resData.msg,
              customClass: "text-danger"
            });
          }

          // Clear Current Session
          sessionStorage.clear();
          this.loading = false;
        })
        .catch(error => {
          if (error.response.status === 419) {
            location.reload();
          }
          this.loading = false;
          console.log(error);
        });
    },

    //registers
    register() {
      //redirect
      window.location.href = "/register";
    },

    // for pdf
    openPdf({ name = null, state = true }) {
      if (!state) {
        this.pdfReadyLoading = state;
      }

      if (name) {
        this.pdfFileName = name;
      }
    },

    // announcement
    announcement() {
      axios
        .get("/super-announcement/announcement")
        .then(response => {
          // console.log(response.data);
          this.announcementMessage = response.data;
          if (this.announcementMessage.length) {
            this.announceDailogShow = true;
          }
        })
        .catch(error => {
          console.log(error.data);
        });
    },

    // handle suggestion
    handleInput() {
      if (this.suggestions.length) {
        this.showSuggestions = true;
      }
    },
    // Select suggestion
    selectSuggestion(suggestion) {
      this.form.login = suggestion;
      this.showSuggestions = false;
    }
  },

  computed: {
    // suggestion
    // filteredSuggestions() {
    //   if (this.suggestions) {
    //     return this.suggestions;
    //   }
    // }
  },

  mounted() {
    this.$Progress.finish();
  },

  created() {
    this.$Progress.start();
    this.announcement();
  }
};
</script>

<style scoped>
.login_bg {
  background: rgb(10, 10, 10);
  height: 100vh;
}
.main-bg {
  height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  position: relative;
  width: 380px;
  height: 450px;
  background: #131212;
  border-radius: 8px;
  overflow: hidden;
}

.box::before {
  content: "";
  z-index: 1;
  position: absolute;
  top: -50%;
  left: -50%;
  width: 440px;
  height: 470px;
  transform-origin: bottom right;
  background: linear-gradient(0deg, transparent, #84ffff, #14e7e7);
  animation: animate 6s linear infinite;
}
.box::after {
  content: "";
  z-index: 1;
  position: absolute;
  top: -50%;
  left: -50%;
  width: 380px;
  height: 450px;
  transform-origin: bottom right;
  background: linear-gradient(0deg, transparent, #48da78, #07a556);
  animation: animate 6s linear infinite;
  animation-delay: -3s;
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.login_form {
  position: absolute;
  inset: 4px;
  background: #f8f8fa;
  border-radius: 8px;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.links {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.links a {
  margin: 10px 0;
  font-size: 0.95em;
  color: #8f8f8f;
  text-decoration: none;
}

.footer_text {
  font-size: 0.75em;
  color: #8f8f8f;
}

.links :hover,
.links a:hover,
.links a:nth-child(2) {
  color: #0f0f0f;
}

.bottom_info_btn {
  position: absolute;
  bottom: 40px;
  right: 40px;
}

.trin-trin {
  animation-name: trin;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes trin {
  from {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  20%,
  32%,
  44%,
  56%,
  68% {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  23%,
  35%,
  47%,
  59%,
  71% {
    transform: rotate3d(0, 0, 1, 15deg);
  }
  26%,
  38%,
  50%,
  62%,
  74% {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  29%,
  41%,
  53%,
  65%,
  77% {
    transform: rotate3d(0, 0, 1, -15deg);
  }
  80% {
    transform: rotate3d(0, 0, 1, 0deg);
  }
}

.resultBox {
  max-height: 110px;
  overflow: auto;
  position: absolute;
  z-index: 8;
  width: 265px;
  margin-top: -25px;
}

.v-tooltip__content {
  background-color: transparent;
}

.v-menu__content {
  margin-top: -50px !important;
}
</style>
